/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off' */
import $ from 'jquery';
import reportModelBuilder from '@/scripts/logisticRegression/reportModelBuilder';
import apiHelper from '@/scripts/logisticRegression/apiHelper';
import commonApiHelper from '@/scripts/commonApiHelper';
import current from '@/scripts/current';
import store from '@/store';
import metricsHelper from '@/scripts/metricsHelper';
import commonTestHelper from '../commonTestHelper';
import commonModelHelper from '../commonModelHelper';

export default {
    addSelectionParameters: function (parameters, selectionModel) {
        if (!selectionModel.reference)
            selectionModel.reference = current.modelHelper.buildBlankReference();
        commonApiHelper.addYearAndLocation(parameters);
        commonApiHelper.addVariableParameter(parameters, selectionModel.v.dependent, 'dependent_var');
        var values = selectionModel.v.independent.map(v => commonApiHelper.getApiVariableName(v.variable));
        parameters.push({ queryCode: 'independent_vars', value: values.join(',') });
        parameters.push({ queryCode: 'dependent_reference_level', value: selectionModel.reference.dependent });
        parameters.push({ queryCode: 'independent_reference_levels', value: selectionModel.reference.independent.join(',') });
    },
    //&survey_year=2014&state=2&depvar=R_PNEUMOC&indepvar=R_AIDSTST=2&R_AIDSTST_labelref=1&ref_cat=1&depvar_model_level=1">Original</a></td>
    getReportParameters: function (selectionModel) {
        var parameters = [];
        commonApiHelper.addServiceParameters(parameters, process.env.VUE_APP_LR_SAS_PROGRAM);
        apiHelper.addSelectionParameters(parameters, selectionModel);
        parameters.push({ queryCode: 'output_format', value: 'json' });
        return commonApiHelper.toQueryString(parameters)
    },
    saveLogData: function (data) {
        if (data.errorMessages.length === 0) {
            var logData = {
                selectionModel: current.selectionModel,
                executionTime: data.recordTotals.executionTime.trim()
            };
            //commonApiHelper.saveLogData(logData);
        }
    },
    loadFromApi: function (vm, apiFormData, showUnweighted, $router) {
        var selectionModel = current.selectionModel;
        store.dispatch('results/startLrAnalysis', { apiFormData, selectionModel });
        store.dispatch('selModel/startLrAnalysis', {});
        //new JsonSerializerSettings
        //{
        //  Culture = new CultureInfo("en")
        //};
        //$.ajaxSetup({
        //  contents: {
        //    mycustomtype: /mycustomtype/
        //  },
        //  converters: {
        //    //'mycustomtype json': function (result) {
        //   'text json': function (result) {
        //      // Do stuff
        //      console.log(result);
        //      return JSON.parse(result)
        //    }
        //  }
        //});
        store.dispatch('display/setIsLoading', true);
        $.ajax({
            url: process.env.VUE_APP_SAS_BROKER,
            type: 'POST',
            data: apiFormData,
            success: function (data) {
                store.dispatch('display/setIsLoading', false);

                metricsHelper.reportLoaded();
                var links = store.state.display.breadCrumbLinks;
                var onReportPage = links.length > 0 && links[links.length-1].name === 'logisticRegressionViewReport';
                const results = store.state.results;
                if (results.analysisType === 'lr' && results.apiFormData === apiFormData && results.loadingData) {
                    store.dispatch('results/loadedData', { apiFormData, data });
                    if (!onReportPage)
                        store.dispatch('display/setReportLoadedMessage');
                }
                if (onReportPage)
                    apiHelper.populateReportModel(data, vm);
                //apiHelper.saveLogData(data);  //Save file for calculating execution time.  Runs only locally
                commonTestHelper.nextIfTesting($router, true);
            },
            error: function (jqXHR, b, c) {
                store.dispatch('display/setIsLoading', false);
                console.log('API Error', jqXHR);
                metricsHelper.reportFailed();
                vm.errorCode = 'ajax'
                store.dispatch('display/setIsLoading', false);
                commonTestHelper.nextIfTesting($router, false);
            }
        });
    },
    populateReportModel: function (data, vm) {
        if (data.errorMessages === undefined || data.errorMessages === null) {
            vm.errorCode = '1';
            console.log('Server Error', data)
            metricsHelper.serverError();
            vm.errorMessages = ['Server Error'];
        } else if (data.errorMessages.length > 0) {
            if (data.errorMessages[0] === 'No valid data on file') {
                populateReportModelData(data, vm);
                vm.noData = true;
            } else {
                vm.errorCode = '1';
                vm.errorMessages = data.errorMessages;
            }

        } else {
            populateReportModelData(data, vm);
        }
        store.dispatch('display/setIsLoading', false);
    }
}
function variableHasLevelWithNoData(variable) {
    return variable.levels.filter(r => r.totalSourceRecords === 0).length > 0;
}
function populateReportModelData(data, vm) {
    vm.reportModel = reportModelBuilder.build(data);
    vm.independent = vm.reportModel.parms.independentVariables.map(v => buildVariable(v));
    vm.noSourceRecords = vm.independent.filter(v => variableHasLevelWithNoData(v)).length > 0;
    vm.originalData = data;
    vm.errorMessages = [];
}

function buildVariable(variableSelection) {
    return {
        variable: variableSelection.variable.variable,
        title: variableSelection.variable.variableTitle,
        levels: variableSelection.categories.map(c => addTotalSourceRecords(c, variableSelection)),
        totalSourceRecords: commonModelHelper.getNumberOfSourceRecords(0, variableSelection.type)
    };
}
function addTotalSourceRecords(category, variableSelection) {
    return {
        id: category.id,
        title: category.title,
        totalSourceRecords: commonModelHelper.getNumberOfSourceRecords(category.code, variableSelection.type)
    }
}

// function getNumberOfSourceRecordsCt(levelId, variableType) {
//   let yearLevelId = variableType === 'year' ? levelId : 0;
//   let locationLevelId = variableType === 'location' ? levelId : 0;
//   return store.state.report.deprecatedCountsByYearState[yearLevelId][locationLevelId];
// }
